// extracted by mini-css-extract-plugin
export default {"add":"addReceipt_add__kYIqa"};